import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/navbar.css';

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu on route change
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname]);

    const navItems = [
        { name: 'Mission', path: '/#mission' },
        { name: 'Our Edge', path: '/#capabilities' },
        { name: 'Products', path: '/#products' },
        { name: 'Why Us', path: '/#why-choose-us' },
    ];

    const handleNavClick = (e, path) => {
        if (location.pathname === '/' && path.startsWith('/#')) {
            e.preventDefault();
            const id = path.replace('/#', '');
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setMobileMenuOpen(false);
    };

    const isAlwaysVisible = location.pathname !== '/';

    return (
        <>
            <nav className={`global-navbar ${scrolled ? 'scrolled' : ''} ${isAlwaysVisible ? 'always-visible' : ''}`}>
                <div className="navbar-container">
                    <Link to="/" className="navbar-brand" onClick={() => window.scrollTo(0, 0)}>
                        <img src="/logo512.png" alt="Sitcorp International" className="navbar-logo-img" />
                    </Link>

                    <div className="navbar-links">
                        {navItems.map((item) => (
                            <a 
                                key={item.name} 
                                href={item.path} 
                                onClick={(e) => handleNavClick(e, item.path)}
                                className={`nav-link`}
                            >
                                {item.name}
                            </a>
                        ))}
                    </div>

                    <button 
                        className="mobile-menu-btn" 
                        onClick={() => setMobileMenuOpen(true)}
                        aria-label="Open menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </nav>

            <div 
                className={`mobile-nav-overlay ${mobileMenuOpen ? 'open' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
            ></div>

            <div className={`mobile-nav-drawer ${mobileMenuOpen ? 'open' : ''}`}>
                <button 
                    className="close-menu-btn" 
                    onClick={() => setMobileMenuOpen(false)}
                    aria-label="Close menu"
                >
                    &times;
                </button>
                <div className="mobile-nav-links">
                    {navItems.map((item) => (
                        <a 
                            key={`mobile-${item.name}`} 
                            href={item.path} 
                            onClick={(e) => handleNavClick(e, item.path)}
                            className={`mobile-nav-link`}
                        >
                            {item.name}
                        </a>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Navbar;
